import Calamities from "@/components/calamities/Calamities";
import PotentialCalamityDetail from "@/components/calamities/PotentialCalamitiesDetail";
import PotentialCalamities from "@/components/calamities/PotentialCalamities";
import PotentialCalamitiesReport from "@/components/calamities/PotentialCalamitiesReport";
import PotentialCalamityDetailReport from "@/components/calamities/PotentialCalamitiesDetailReport";
import CalamityMap from "@/components/calamities/CalamityMap";

export default [
  {
    path: "/calamities",
    name: "Calamities",
    component: Calamities,
    meta: {
      requiresAuthentication: true
    }
  },
  {
    path: "/potential-calamities",
    name: "PotentialCalamities",
    component: PotentialCalamities,
    meta: {
      requiresAuthentication: true
    }
  },
  {
    path: "/potential-calamities/:id",
    name: "PotentialCalamitiesDetail",
    component: PotentialCalamityDetail,
    meta: {
      requiresAuthentication: true
    }
  },
  {
    path: "/potential-calamities-report",
    name: "PotentialCalamitiesReport",
    component: PotentialCalamitiesReport,
    meta: {
      requiresAuthentication: true
    }
  },
  {
    path: "/potential-calamities-report/:id",
    name: "PossibleCalamitiesDetailReport",
    component: PotentialCalamityDetailReport,
    meta: {
      requiresAuthentication: true
    }
  },
  {
    path: "/calamity-map",
    name: "CalamityMap",
    component: CalamityMap,
    meta: {
      requiresAuthentication: true
    }
  }
];
